import { z } from 'zod';

import type { IdCompanyDto } from '@/services/ws-companies/src/main/resources/rest-api';
import type { AdvertiserDto, CampaignStatus, IdAdvertiserDto } from '@/services/ws-selfbooking/src/main/resources/rest-api';

import type { Option } from 'src/types';

export enum CustomCampaignStatuses {
  ALL = 'ALL',
}

export type ExtendedCampaignStatus = CampaignStatus | CustomCampaignStatuses;

export type FiltersState = {
  search: string;
  status: ExtendedCampaignStatus;
  advertiserId: Option<AdvertiserDto> | null;
  companyId: Option<IdCompanyDto> | null;
};

export enum CampaignsListSearchKey {
  ADVERTISER_ID = 'advertiserId',
  STATUS = 'status',
}

export interface CampaignsListSearchParams {
  [CampaignsListSearchKey.ADVERTISER_ID]?: IdAdvertiserDto;
  [CampaignsListSearchKey.STATUS]?: CampaignStatus;
}

export const campaignsListRouterSearchParamsSchema = z.object({
  [CampaignsListSearchKey.ADVERTISER_ID]: z.string().optional(),
  [CampaignsListSearchKey.STATUS]: z.string().optional(),
});

export interface CampaignsListRouteParams {
  advertiserId: IdAdvertiserDto;
  status: CampaignStatus;
}
